/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'vegetarian': {
    width: 960,
    height: 560,
    viewBox: '0 0 960 560',
    data: '<path pid="0" d="M439 387.7s-88.6-108.5 132.8-197.9c0 0 30.4-6.1 65.7-58.2 0 0 117.4 268.8-170.7 279.2 0 0 27-102 138.9-179.7 0 .1-142.3 59.5-166.7 156.6"/><path pid="1" d="M434.5 380.9s58.5-74.2-92-132c0 0-20.6-3.7-45.1-38.5 0 0-76 182.8 118.5 186.4 0 0-19.4-68.5-95.7-119.7 0 0 96.8 38.4 114.3 103.8"/><path pid="2" _fill="none" d="M487.5 560V49.2"/>'
  }
})
